import { styled } from "@mui/material";

export const DesktopContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: "24px",
});

export const MobileContainer = styled("div")({
  display: "grid",
  position: "fixed",
  maxWidth: "95vw",
  minHeight: "40px",
  minWidth: "40px",
  right: 0,
  top: "calc(50% + 15px)",
  zIndex: 2147483647,
  margin: "7px",
  transform: "none",
});

interface ActionsContainerStyledProps {
  variant?: "desktop" | "mobile";
}

export const ActionsContainerStyled = styled(
  "div"
)<ActionsContainerStyledProps>(({ variant }) => ({
  display: "flex",
  flexDirection: variant === "mobile" ? "column" : "row",
  alignItems: "center",
  gap: variant === "mobile" ? "6px" : "6px",
  marginBottom: variant === "mobile" ? "6px" : "0",
}));

interface ButtonProps {
  variant?: "desktop" | "mobile";
}

export const Button = styled("button")<ButtonProps>(({ variant }) => ({
  width: variant === "mobile" ? "40px" : "30px",
  height: variant === "mobile" ? "40px" : "30px",
  borderRadius: "8px",
  backgroundColor: "var(--color-primary-5)",
  border: "none",
  color: "var(--color-surface)",
  fontSize: "var(--font-subtitle-3)",
  fontWeight: "700",
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
  marginRight: variant === "mobile" ? "0px" : "8px",
  margin: variant === "mobile" ? "3px" : "0",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "&:hover": {
    backgroundColor: "var(--color-primary)",
    color: "var(--color-grey-10)",
  },
  "&:focus": { outline: "none" },
  "&:active": { transform: "scale(0.9)" },
}));

interface LibrasButtonStyledProps {
  variant?: "desktop" | "mobile";
}

interface LibrasButtonStyledProps {
  variant?: "desktop" | "mobile";
}

export const LibrasButtonStyled = styled("button")<LibrasButtonStyledProps>(
  ({ variant }) => ({
    width: variant === "mobile" ? "40px" : "30px",
    height: variant === "mobile" ? "40px" : "30px",
    borderRadius: "8px",
    backgroundColor: "var(--color-primary-5)",
    border: "none",
    color: "var(--color-surface)",
    fontSize: "var(--font-subtitle-3)",
    fontWeight: "700",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    marginRight: variant === "mobile" ? "0px" : "8px",
    margin: variant === "mobile" ? "3px" : "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: variant === "desktop" ? "fixed" : "relative",
    zIndex: variant === "desktop" ? 1000 : "auto",
    top: variant === "desktop" ? "50%" : "auto",
    right: variant === "desktop" ? "16px" : "auto",
    transform: variant === "desktop" ? "translateY(-50%)" : "none",

    "&:hover": {
      backgroundColor: "var(--color-primary)",
      color: "var(--color-grey-10)",
    },
    "&:focus": { outline: "none" },
    "&:active": {
      transform:
        variant === "desktop" ? "scale(0.9) translateY(-50%)" : "scale(0.9)",
    },
  })
);

interface MainButtonStyledProps {
  isOpen: boolean;
}

export const MainButtonStyled = styled("button")<MainButtonStyledProps>(
  ({ isOpen }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: isOpen ? "var(--color-grey-80)" : "var(--color-primary-5)",
    color: "var(--color-surface)",
    borderRadius: isOpen ? "50%" : "8px",
    width: isOpen ? "32px" : "40px",
    height: isOpen ? "32px" : "40px",
    minWidth: isOpen ? "32px" : "40px",
    minHeight: isOpen ? "32px" : "40px",
    marginTop: isOpen ? "4px" : "3px",
    margin: "3px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    fontSize: "var(--font-subtitle-3)",
    fontWeight: "700",

    "&:hover": {
      backgroundColor: isOpen ? "var(--color-grey-90)" : "var(--color-primary)",
      color: isOpen ? "var(--color-surface)" : "var(--color-grey-10)",
    },
    "&:focus": { outline: "none" },
    "&:active": { transform: isOpen ? "scale(0.9)" : "scale(0.95)" },
  })
);
